module.exports = ".centrarBotones {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/modals/modal-message-dialog.component.scss
// module id = ./src/app/shared-components/modals/modal-message-dialog.component.scss
// module chunks = main